import { graphql } from "relay-runtime"

export const dePatientByPatientIdQuery = graphql`
  query dePatientByPatientIdQuery($patientId: UUID!) {
    patientByPatientId: de_patientByPatientId(patientId: $patientId) {
      id
    }
  }
`
